module.exports = __webpack_public_path__ + "img/bk.3799996b.png";